import { inject, Injectable } from '@angular/core';
import { UploadWidgetItemSection } from '@shared/utils/enums';

import { FreeBetLevelsUploadStrategy } from './free-bet-levels-upload.strategy';
import { GameStrategiesUploadStrategy } from './game-strategies-upload.strategy';
import { GamesUploadStrategy } from './games-upload.strategy';
import { UploadSectionStrategy } from './upload-strategy.interface';

/**
 * Picks the {@link UploadSectionStrategy} for a given section. Register a new
 * section by adding its strategy to {@link UploadStrategyResolverService.strategies}.
 */
@Injectable({ providedIn: 'root' })
export class UploadStrategyResolverService {
  private readonly strategies: Map<UploadWidgetItemSection, UploadSectionStrategy> = this.initStrategies();

  resolve(section: UploadWidgetItemSection): UploadSectionStrategy {
    const strategy = this.strategies.get(section);

    if (!strategy) {
      throw new Error(`No upload strategy registered for section: ${section}`);
    }

    return strategy;
  }

  private initStrategies(): Map<UploadWidgetItemSection, UploadSectionStrategy> {
    const registeredStrategies: UploadSectionStrategy[] = [
      inject(GamesUploadStrategy),
      inject(GameStrategiesUploadStrategy),
      inject(FreeBetLevelsUploadStrategy),
    ];
    return new Map(registeredStrategies.map((strategy) => [strategy.section, strategy]));
  }
}
